export default __webpack_public_path__ + "static/media/logo.ef62f2e5.png";